export default __webpack_public_path__ + "images/7f5df82fb2af4bb05dca563bf73c4fb8-pyxir-and-rudy-side-by-side.png";